import { axiosHelper, RequestConfig } from 'utils';

const requestAxiosInstance = axiosHelper.getInstance();

export function request(config: RequestConfig) {
  axiosHelper.transformRequestByDeCamel(requestAxiosInstance, config);
  axiosHelper.transformResponseByCamel(requestAxiosInstance, config);
  axiosHelper.setParamsSerializer(config);

  return requestAxiosInstance(config);
}
